import { Event } from "../Event";
import axios from "../../utilities/axios";
import { Notification } from "rsuite";

export class UserCpfCnpjEvents extends Event {
    
}
